var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import ListItem from "../List/ListItem";
var MenuItem = function (_a) {
    var _b = _a.addOn, addOn = _b === void 0 ? null : _b, _c = _a.addOnDirection, addOnDirection = _c === void 0 ? null : _c, _d = _a.color, color = _d === void 0 ? undefined : _d, onClick = _a.onClick, _e = _a.children, children = _e === void 0 ? null : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.marked, marked = _g === void 0 ? false : _g, _h = _a.upgrade, upgrade = _h === void 0 ? false : _h, _j = _a.groupIndex, groupIndex = _j === void 0 ? null : _j, _k = _a.index, index = _k === void 0 ? null : _k, props = __rest(_a, ["addOn", "addOnDirection", "color", "onClick", "children", "disabled", "marked", "upgrade", "groupIndex", "index"]);
    var getProps = function () { return ({
        tabIndex: disabled ? -1 : 0,
        role: "menuItem"
    }); };
    return (React.createElement(ListItem, __assign({ addOn: addOn, addOnDirection: addOnDirection, color: color, onClick: onClick, disabled: disabled, marked: marked, upgrade: upgrade, index: index, "data-group": groupIndex }, props, getProps()), children));
};
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Menu/MenuItem.js
// module id = 1791
// module chunks = 17